angular
.module('am4')
.controller(
    'facilityMessagesCtrl',
    function(
        messagesService,
        $stateParams,
        $scope,
        $state,
        $rootScope,
        errorService,
        ngDialog
    ) {
        var that = this,
            facilityMessages = messagesService.facility($stateParams.id);
        that.remove = function(message) {
            var dangerScope = $scope.$new();
            dangerScope.confirmTranslation = 'COMFIRM_REMOVE_MESSAGE';
            dangerScope.confirmButtonTranslation = 'REMOVE_MESSAGE';
            dangerScope.confirmTranslationValues = {
                item: message.name
            };

            dangerScope.confirm = function() {
                dangerScope.deactivating = true;
                if (
                    message.equipment_group_id &&
                    message.equipment_group_id !== ''
                ) {
                    return facilityMessages
                    .group(message.equipment_group_id)
                    .remove(message.id, message.equipment_group_id)
                    .then(function() {
                        return getMessages();
                    })
                    .catch(function(e) {
                        errorService.addError(
                            'MESSAGE_REMOVE_ERROR',
                            e
                        );
                    })
                    .finally(function() {
                        ngDialog.closeAll();
                    });
                }

                return facilityMessages
                .remove(message.id)
                .then(function() {
                    return getMessages();
                })
                .catch(function(e) {
                    errorService.addError(
                        'MESSAGE_REMOVE_ERROR',
                        e
                    );
                })
                .finally(function() {
                    ngDialog.closeAll();
                });
            };
            ngDialog.open({
                template: require('../views/modal/danger.html'),
                plain: true,
                scope: dangerScope,
                className: 'ngdialog-theme-plain--danger'
            });
        };
        that.group = $stateParams.group;
        $scope.$watch(
            function() {
                return that.group;
            },
            function(group, oldGroup) {
                if (group !== oldGroup) {
                    $state.go('app.am4.facility.tasks.messages', {
                        group: group
                    });
                }
            }
        );

        getMessages();

        $scope.$on('messages:refresh', getMessages);
        that.loading = true;
        delete that.messages;

        function getMessages() {
            var task;
            if (that.group) {
                task = facilityMessages.group(that.group).all();
            } else {
                task = facilityMessages.all();
            }
            return task
            .then(function(messages) {
                that.messages = messages;
            })
            .catch(function() {
                delete that.messages;
            })
            .finally(function() {
                that.loading = false;
            });
        }
    }
);



// WEBPACK FOOTER //
// ./src/app/controllers/facilityMessagesCtrl.js